export default "__VITE_ASSET__925385f9__"